import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { spacings } from '../spacings';
import {
  SubheadingText,
  SubheadingTextProps,
} from '../TextStyles/SubheadingText';

interface OwnProps {
  SubheadingProps?: SubheadingTextProps;
}

interface SubheadingProps extends OwnProps, WithStyles<typeof styles> {}

const SubheadingBase: FunctionComponent<SubheadingProps> = ({
  SubheadingProps: subheadingProps,
  children,
  classes,
}) => (
  <div className={classes.root}>
    <SubheadingText {...subheadingProps} className={classes.subheading}>
      {children}
    </SubheadingText>
  </div>
);

// styled
const styles = (theme: Theme) => {
  const { subheading: subheadingSpacing } = spacings(theme);

  return createStyles({
    root: {
      ...subheadingSpacing,
    },
    subheading: {},
  });
};

const enhance = compose<SubheadingProps, OwnProps>(
  pure,
  withStyles(styles),
);

/**
 * Subheading
 *
 * @zeplin {@link https://zpl.io/am5JY5r }
 */
export const Subheading = enhance(SubheadingBase);

Subheading.displayName = 'Subheading';
